import { createCachedSearchService } from "./createCachedSearchService";

export const getMedicalProceduresSuggestions = createCachedSearchService(
  "mekidoc-medical-procedures",
  "medical procedures suggestions"
);
